import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 28 28"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "#1D847E",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M5.833 16.667c-2.16.953-3.5 2.281-3.5 3.75 0 2.9 5.223 5.25 11.667 5.25 6.443 0 11.666-2.35 11.666-5.25 0-1.469-1.34-2.797-3.5-3.75M21 9.333c0 4.741-5.25 7-7 10.5-1.75-3.5-7-5.759-7-10.5a7 7 0 0 1 14 0m-5.834 0a1.167 1.167 0 1 1-2.333 0 1.167 1.167 0 0 1 2.333 0"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }